// Accent color — the player-chosen UI accent. The whole HUD is themed off the
// --gold / --gold-bright CSS variable pair (see hud.css :root); switching accent
// just overrides those two custom properties on <html>. Gold is the default and
// matches the values baked into hud.css, so 'gold' is effectively a no-op reset.

import { getSetting, onSettingChange } from './settings.js'

// Each accent supplies a base + a brighter highlight, mirroring the original
// --gold / --gold-bright relationship. `swatch` is what the picker renders.
export const ACCENTS = [
  { key: 'gold',    label: 'Gold',    base: '#d4a548', bright: '#ecc06b' },
  { key: 'jade',    label: 'Green',   base: '#3bb35c', bright: '#63d684' },
  { key: 'sky',     label: 'Sky',     base: '#6c8aa8', bright: '#8fb0cf' },
  { key: 'crimson', label: 'Crimson', base: '#c8585c', bright: '#e07f83' },
  { key: 'violet',  label: 'Violet',  base: '#9c7ab0', bright: '#bd9bd0' },
  { key: 'rose',    label: 'Rose',    base: '#c87a96', bright: '#e09cb6' },
]

export const DEFAULT_ACCENT = 'gold'

function paletteFor(key) {
  return ACCENTS.find((a) => a.key === key) || ACCENTS[0]
}

// '#rrggbb' → 'r, g, b' (channels only, so callers can build rgba(..., alpha)).
function rgbChannels(hex) {
  const n = parseInt(hex.slice(1), 16)
  return `${(n >> 16) & 0xff}, ${(n >> 8) & 0xff}, ${n & 0xff}`
}

// Push the chosen accent into the live CSS variables every other style reads.
// Also publishes RGB-channel variants (--gold-rgb / --gold-bright-rgb) for the
// places that need rgba() with their own alpha (e.g. the UI minimap tints).
export function applyAccent(key = getSetting('accentColor')) {
  const { base, bright } = paletteFor(key)
  const root = document.documentElement
  root.style.setProperty('--gold', base)
  root.style.setProperty('--gold-bright', bright)
  root.style.setProperty('--gold-rgb', rgbChannels(base))
  root.style.setProperty('--gold-bright-rgb', rgbChannels(bright))
}

// Apply once now and keep the live page in sync when the setting changes.
export function initAccent() {
  applyAccent()
  onSettingChange((k, v) => {
    if (k === 'accentColor') applyAccent(v)
  })
}
